function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSingle = function SvgSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M18.4 4.4H5.6c-.7 0-1.2.5-1.2 1.2v12.9c0 .7.5 1.2 1.2 1.2h12.9c.7 0 1.2-.5 1.2-1.2V5.6c0-.7-.5-1.2-1.2-1.2Z",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }));
};
export default SvgSingle;